"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DIDDocumentLite = void 0;
var did_ethr_resolver_1 = require("@ew-did-registry/did-ethr-resolver");
var DIDDocumentLite = /** @class */ (function () {
    /**
  * @param {string} did
  * @param {IResolver} resolver
  */
    // eslint-disable-next-line no-useless-constructor
    function DIDDocumentLite(did, resolver) {
        this.did = did;
        this.resolver = resolver;
    }
    /**
     * Returns the current owner for certain DID.
     * If owner not assigned explicitly than identity is the owner of itself
     *
     * @param {string} did
     * @returns {Promise<string>}
     */
    DIDDocumentLite.prototype.getController = function (did) {
        if (did === void 0) { did = this.did; }
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.resolver.identityOwner(did)];
            });
        });
    };
    /**
     * Checks if the delegate is present for a particular DID.
     *
     * @param {DelegateTypes} delegateType
     * @param {string} delegateDID
     * @param {string} did
     * @returns {Promise<boolean>}
     */
    DIDDocumentLite.prototype.isValidDelegate = function (delegateType, delegateDID, did) {
        if (did === void 0) { did = this.did; }
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.resolver.validDelegate(did, delegateType, delegateDID)];
            });
        });
    };
    /**
     * Finds first attribute which satisfies filter
     *
     * @param selector {{ [attr: string]: { [prop: string]: string } }} object used
     *  to describe part of the document. `attr` is one of standard DID attributes
     *  like `publicKey`, `serviceEndpoints` or `authentication` and `prop` - properties
     *  of this attribute such as `type` or `value`
     * @param did {string}
     *
     * @returns {object | null}
     */
    DIDDocumentLite.prototype.readAttribute = function (selector, did) {
        if (did === void 0) { did = this.did; }
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.resolver.readAttribute(did, selector)];
            });
        });
    };
    /**
     * Returns document of the given `did`
     *
     * @param did {string}
     */
    DIDDocumentLite.prototype.read = function (did) {
        if (did === void 0) { did = this.did; }
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.resolver.read(did)];
            });
        });
    };
    DIDDocumentLite.prototype.ownerPubKey = function (did) {
        if (did === void 0) { did = this.did; }
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.resolver.readOwnerPubKey(did)];
            });
        });
    };
    DIDDocumentLite.prototype.lastBlock = function (did) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.resolver.lastBlock(did)];
            });
        });
    };
    DIDDocumentLite.prototype.readFromBlock = function (did, from) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.resolver.readFromBlock(did, from)];
            });
        });
    };
    DIDDocumentLite.prototype.fromLogs = function (logs, did) {
        if (did === void 0) { did = this.did; }
        return did_ethr_resolver_1.documentFromLogs(did, logs);
    };
    return DIDDocumentLite;
}());
exports.DIDDocumentLite = DIDDocumentLite;
//# sourceMappingURL=index.js.map